import { render } from "./ModalTableMergeConfirm.vue?vue&type=template&id=07fa5ca7"
import script from "./ModalTableMergeConfirm.vue?vue&type=script&lang=js"
export * from "./ModalTableMergeConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__